<template>
  <div class="main-container">
    <loading :isShow="listLoading" />
    <Button type="primary" class="btn export" @click="exportDetailData">导出本页费用明细</Button>
    <Button class="back-btn" type="primary" ghost @click="back()">返回</Button>

    <div class="top clearfix">
      <div class="its">
        <div class="label">业务员：</div>
        <div class="value">{{ infoForm.staffNo }}/{{ infoForm.userName }}</div>
      </div>
      <div class="its" v-if="$units.isOkBao() || $units.isOkTX()">
        <div class="label">上级主管：</div>
        <div class="value" v-if="infoForm.leaderStaffNo && infoForm.leaderName">{{ infoForm.leaderStaffNo + '/' +infoForm.leaderName }}</div>
      </div>
      <div class="its" v-if="$units.isOkBao() || $units.isOkTX()">
        <div class="label">所属团队：</div>
        <div class="value">{{ infoForm.groupName }}</div>
      </div>
      <div class="its" v-if="$units.isOkBao() || $units.isOkTX()">
        <div class="label">所属机构：</div>
        <div class="value">{{ infoForm.orgName }}</div>
      </div>
      <div class="its">
        <div class="label">入职日期：</div>
        <div class="value">{{ infoForm.entryTime | filterTime('YYYY-MM-DD') }}</div>
      </div>
      <div class="its">
        <div class="label">结算日期：</div>
        <div class="value">{{ infoForm.settlementDate | filterTime('YYYY-MM-DD') }}</div>
      </div>
      <div class="its">
        <div class="label">费用日期：</div>
        <div class="value">{{ infoForm.commissionDate | filterTime('YYYY-MM-DD') }}</div>
      </div>
      <div v-if="infoForm.rankName" class="its">
        <div class="label">结算职级：</div>
        <div class="value">{{ infoForm.rankName }}</div>
      </div>
      <div v-if="infoForm.baseMethodName" class="its">
        <div class="label">结算基本法：</div>
        <div class="value">{{ infoForm.baseMethodName }}</div>
      </div>
    </div>

    <div class="loading" v-show="loading">
      <Spin fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>

    <div v-show="!loading">
      <template v-if="isShowTable8">
        <div class="title">基本法收益项明细</div>
        <div class="tableBox">
          <detailTable8 @showTable="showTable" :showPage="false"></detailTable8>
        </div>
      </template>
      <template v-if="isShowTable1">
        <div class="title">基本法外首期基础费用</div>
        <div class="tableBox">
          <detailTable1 @showTable="showTable"></detailTable1>
        </div>
      </template>
      <template v-if="isShowTable9">
        <div class="title">基本法扣款</div>
        <div class="tableBox">
          <detailTable9 @showTable="showTable" :showPage="false"></detailTable9>
        </div>
      </template>

      <template v-if="isShowTable2">
        <div class="title">限时加费活动</div>
        <div class="tableBox">
          <detailTable2 @showTable="showTable"></detailTable2>
        </div>
      </template>

      <template v-if="isShowTable3">
        <div class="title">基本法外续期基础费用</div>
        <div class="tableBox">
          <detailTable3 @showTable="showTable"></detailTable3>
        </div>
      </template>

      <template v-if="isShowTable4">
        <div class="title">首年后置费用</div>
        <div class="tableBox">
          <detailTable4 @showTable="showTable"></detailTable4>
        </div>
      </template>

      <template v-if="isShowTable5">
        <div class="title">团队长首期管理费</div>
        <div class="tableBox">
          <detailTable5 @showTable="showTable"></detailTable5>
        </div>
      </template>

      <template v-if="isShowTable6">
        <div class="title">团队长续期管理费</div>
        <div class="tableBox">
          <detailTable6 @showTable="showTable"></detailTable6>
        </div>
      </template>

      <template v-if="isShowTable7">
        <div class="title">团队长后置费用</div>
        <div class="tableBox">
          <detailTable7 @showTable="showTable"></detailTable7>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import detailTable1 from './components/detailTable1';
import detailTable2 from './components/detailTable2';
import detailTable3 from './components/detailTable3';
import detailTable4 from './components/detailTable4';
import detailTable5 from './components/detailTable5';
import detailTable6 from './components/detailTable6';
import detailTable7 from './components/detailTable7';
import detailTable8 from './components/detailTable8';
import detailTable9 from './components/detailTable9';
export default {
  mixins: [common, pageTool],
  components: {
    detailTable1,
    detailTable2,
    detailTable3,
    detailTable4,
    detailTable5,
    detailTable6,
    detailTable7,
    detailTable8,
    detailTable9
  },

  data() {
    return {
      infoForm: {},
      isShowTable1: true,
      isShowTable2: true,
      isShowTable3: true,
      isShowTable4: true,
      isShowTable5: true,
      isShowTable6: true,
      isShowTable7: true,
      isShowTable8: true,
      isShowTable9:true,
      settlementDate: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      userName: '',
      groupName: '',
      orgName: '',
      entryTime: '',
      loading: true
    };
  },

  created() {
    const { settlementDate, userName, groupName, orgName, entryTime } = this.$route.query;
    this.settlementDate = settlementDate;
    this.userName = userName;
    this.groupName = groupName;
    this.orgName = orgName;
    this.entryTime = entryTime;
    this.getDetial();
  },

  methods: {
    getDetial() {
      this.$http({
        url: '/buz/userSettlementDetail/baseMethod/detailInfo',
        type: 'GET',
        data: {
          id: this.$route.query.detailId
        }
      }).then(res => {
        this.infoForm = res.data;
      });
    },
    exportDetailData() {
      if (!this.$units.pointAction('offline_81_1_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const { reportId, tabVal, orgId, userId } = this.$route.query;
      let data = {
        reportId
      };
      if (tabVal == 1) {
        data.userId = userId;
      } else {
        data.orgId = orgId;
      }
      this.$units.downloadFile('/buz/userSettlementDetail/exportDetail', data, 'POST');
    },

    showTable(data, type) {
      this.loading = true;
      if (type == 1) {
        this.isShowTable1 = data;
      } else if (type == 2) {
        this.isShowTable2 = data;
      } else if (type == 3) {
        this.isShowTable3 = data;
      } else if (type == 4) {
        this.isShowTable4 = data;
      } else if (type == 5) {
        this.isShowTable5 = data;
      } else if (type == 6) {
        this.isShowTable6 = data;
      } else if (type == 7) {
        this.isShowTable7 = data;
      } else if (type == 8) {
        this.isShowTable8 = data;
      }else if (type == 9) {
        this.isShowTable9 = data;
      }
      setTimeout(() => {
        this.loading = false;
      }, 1200);
    }
  }
};
</script>

<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.loading {
  position: absolute;
  width: 98%;
  height: 95%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.export {
  margin-bottom: 20px;
}
.back-btn {
  position: absolute;
  right: 20px;
}
.top {
  padding: 10px 0 25px 0px;
  padding-bottom: 0;
  .its {
    > div {
      float: left;

      &.label {
        font-weight: bold;
        color: #515c6f;
        font-size: 14px;
        margin-right: 10px;
      }

      &.value {
        color: #272933;
      }
    }

    width: 25%;
    float: left;
    margin-bottom: 20px;
  }
}
.title {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 15px;
}
.tableBox {
  margin-bottom: 80px;
}
</style>
